import { createAuthClient } from 'better-auth/react';

export const authClient = createAuthClient({
  basePath: '/families/api/auth',
});

export type Session = typeof authClient.$Infer.Session;

export const { signIn, signOut, useSession } = authClient;
